import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import FontFa from "../../../../../components/fontFa/fontFa";
import { useEmployee } from "../../../../../hook";
import { useGetDetailRequests } from "../hooks/get-detail-request";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { Skeleton } from "antd";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { useSelector } from "../../../../../store/store";
import {
  getApproverName,
  getEmployeeDetail,
} from "../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { RenderProgress } from "../../../human-organization/summary-employee-request/utils/render-helper";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";

export const Progress: FC = () => {
  const { data: employees, isLoading: isLoadingEmployees } = useEmployee();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { data: detail, isLoading: isLoadingDetailRequest }: any = useGetDetailRequests();

  const { getITLeadITHeadAssignee } = useSoftwares();

  if (isLoadingEmployees || isLoadingDetailRequest) return <Skeleton />;

  const progress = [
    {
      status: detail?.fields?.eApprovedStatus,
      name:
        detail?.fields?.eApprovedName ||
        getEmployeeDetail(detail?.fields?.eApprovedBy?.toLowerCase(), employees, softwares)?.[0]?.Title,
      email: getEmployeeDetail(detail?.fields?.eApprovedBy?.toLowerCase(), employees, softwares)?.[0]?.eMail,
      approvedDate: detail?.fields?.eApprovedDate,
      title: "Thủ trưởng cơ quan đơn vị",
    },
    {
      status: detail?.fields?.eApprovedByITLeadStatus,
      name: getApproverName(
        detail?.fields?.eApprovedByITLead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.SR).eAssignee,
      ),
      email: getEmployeeDetail(detail?.fields?.eApprovedByITLead, employees, softwares)?.[0]?.eMail,
      approvedDate: detail?.fields?.eApprovedByITLeadDate,
      title: "Bộ phận hành chính VPCT",
    },
  ];

  return (
    <Box title="Quy trình duyệt">
      <div className="TimelineBox horizontal mdHorizontal mdSmall">
        <div className="item">
          <div className="step approved">
            <FontFa name="faCheck" />
          </div>
          <div className="content">
            <div className="rank">
              <h6>Khởi tạo</h6>
            </div>
            <div className="title">{detail?.createdBy?.user?.displayName}</div>
            <div className="title">{detail?.createdBy?.user?.email} </div>
            <div className="time">
              {`Ngày tạo: ${getDDMMYYYFormat(detail?.createdDateTime)} - ${getHHmmFormat(detail?.createdDateTime)}`}
            </div>
          </div>
        </div>

        <RenderProgress progress={progress} />
      </div>
    </Box>
  );
};
